import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import Button from "../../components/CustomButtons/Button.js";

const DocumentReview = ({ classes, documentDetails }) => {
    const [preview, setPreView] = useState("");
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <Grid container>
            <Grid item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton}
                onClick={() => setPreView(value)}
              >
                Preview
              </Button>
            </Grid>
          </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Document Details
        </h2>
      </Grid>

      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
            {itemView("Sanction Letter", documentDetails?.sanctionletter || "NA")}
          </Grid>
          {preview !== "" &&
            <iframe src={`${preview}#toolbar=0`} width="100%" height="500px" />
          }
        </Grid>
      </Grid>
    </Grid>
  );
};

DocumentReview.propTypes = {
  classes: PropTypes.object,
  documentDetails: PropTypes.object,
};

export default DocumentReview;
